import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import Stack from '@mui/material/Stack';
import { useTheme } from '@mui/material/styles';
import * as React from 'react';

interface ErrorTagContainerProps {
  children: React.ReactNode;
}

const ErrorTagContainer = ({ children }: ErrorTagContainerProps) => {
  const theme = useTheme();

  return (
    <Stack
      direction="row"
      alignItems="center"
      gap="10px"
      sx={{
        padding: '8px 16px',
        border: `1px solid ${theme?.palette?.toastError?.[100]}`,
        background: theme?.palette?.toastError?.[50],
        borderRadius: '4px',
        marginBottom: '16px'
      }}
    >
      <ErrorOutlineIcon
        sx={{
          color: theme?.palette?.toastError?.[500]
        }}
      />
      <Stack
        sx={{
          fontSize: '12px',
          fontWeight: 400,
          color: theme?.palette?.common?.black,
          fontFamily: theme?.MojitoClaim?.font?.tertiary
        }}
      >
        {children}
      </Stack>
    </Stack>
  );
};

export default ErrorTagContainer;
